import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductType } from "src/models/Products/ProductType.models";

interface ProductTypeState {
  productTypes: IProductType[];
  productTypeToEdit: IProductType | null;
}

const initialState: ProductTypeState = {
  productTypes: [],
  productTypeToEdit: null,
};

const productTypeSlice = createSlice({
  name: "ProductType",
  initialState,
  reducers: {
    setProductTypeList: (state, action: PayloadAction<IProductType[]>) => {
      state.productTypes = action.payload;
    },
    concatListProductType: (
      state: ProductTypeState,
      action: PayloadAction<IProductType[]>
    ) => {
      state.productTypes = [...state.productTypes.concat(action.payload)];
    },
    setProductTypeToEdit: (
      state,
      action: PayloadAction<IProductType | null>
    ) => {
      state.productTypeToEdit = action.payload;
    },
    addProductType: (state, action: PayloadAction<IProductType>) => {
      state.productTypes.push(action.payload);
    },
    updateProductType: (state, action: PayloadAction<IProductType>) => {
      let itemIndex = state.productTypes.findIndex(
        item => item.productTypeId === action.payload.productTypeId
      );
      if (itemIndex !== -1) state.productTypes[itemIndex] = action.payload;
    },
    deleteProductType: (state, action: PayloadAction<number>) => {
      const newArray = state.productTypes.filter(
        item => item.productTypeId !== action.payload
      );
      state.productTypes = newArray;
    },
  },
});

export const {
  setProductTypeList,
  concatListProductType,
  setProductTypeToEdit,
  addProductType,
  updateProductType,
  deleteProductType,
} = productTypeSlice.actions;

export default productTypeSlice.reducer;
